import gql from 'graphql-tag';

export const UsersReadTimeQuery = gql`
  query usersReadTime($where: userReadTime_bool_exp, $order_by: [userReadTime_order_by!]) {
    userReadTime(order_by: $order_by, limit: 20, where: $where) {
      id
      total
      data
      readToday
      jan
      feb
      mar
      april
      may
      june
      july
      aug
      sept
      oct
      nov
      dec
      user {
        id
        firstName
        avatarUrl
        lastName
        username
      }
    }
  }
`;

export const NumberOfbooksReadQuery = gql`
  query NumberOfbooksRead($userId: uuid!, $start: timestamptz!, $end: timestamptz!){
    userBook_aggregate(where: {userId: {_eq: $userId},  updatedAt: { _gte: $start, _lt: $end }}) {
      aggregate {
        count
      }
    }
  }
`;
